module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-org"
  }, [_c('div', {
    staticClass: "step2"
  }, [_c('div', {
    staticClass: "step2-box"
  }, [_c('h2', [_vm._v("备案承诺申明")]), _vm._v(" "), _c('p', {
    staticClass: "step2-p1"
  }, [_vm._v(" 本单位承诺，办理" + _vm._s(_vm.message) + "备案手续的拟备案信息真实、完整、准确，符合法律法规，声明对其填报内容和提交资料的真实性、合法性、准确性、完整性负责，若本单位违反承诺错误备案、虚假备案、恶意备案，由此产生的一切后果，由本申报单位自行承担。")]), _vm._v(" "), _c('p', {
    staticClass: "step2-p2"
  }, [
    [_c('el-checkbox', {
      staticClass: "color-red",
      on: {
        "change": _vm.changecuk
      },
      model: {
        value: (_vm.checked),
        callback: function($$v) {
          _vm.checked = $$v
        },
        expression: "checked"
      }
    }, [_vm._v("本单位同意以上备案承诺申明全部内容")])]
  ], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ec69ea0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/weather/comfirmFile.vue
// module id = 1235
// module chunks = 2